import { apiGet, apiPatch } from './client';
import type { RatingCompany, RatingCompanyBatchRequest } from '../types/RatingCompany';

export function getRatingCompanies(): Promise<RatingCompany[]> {
  return apiGet<RatingCompany[]>('/api/rating-companies');
}

export function saveBatchRatingCompanies(
  added: RatingCompany[],
  modified: RatingCompany[],
  deletedIds: number[],
): Promise<RatingCompany[]> {
  return apiPatch<RatingCompanyBatchRequest, RatingCompany[]>(
    '/api/rating-companies/batch',
    { added, modified, deleted: deletedIds },
  );
}
